'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var treeViewComponent = exports.treeViewComponent = {
    template: require('./tree-view.html'),
    bindings: {
        items: '<',
        level: '<',
        isLink: '<',
        limit: '<',
        category: '<',
        changeFilters: '&'
    },
    controllerAs: 'vm',
    controller: function controller() {
        'ngInject';

        var vm = this;
        vm.onChangeFilters = onChangeFilters;

        function onChangeFilters($event) {
            vm.changeFilters({ $event: $event });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./features/common/tree-view.js
// module id = 924
// module chunks = 0